import React from "react";

import HomeBanners from "./_banners";
import HomeHeroSection from "./_hero";
import HomeHowItWorks from "./_how_it_works";
import HomeNav from "./_nav";

import HomeGetInTouch from "./_get_in_touch";
import "./styles.scss";
import HomeFAQs from "./_frequently_asked_questions";
import HomeFooter from "./_footer";
import { AppName } from "../../Lib/Data";
import { PerformRequest } from "../../Lib/usePerformRequest";
import { Endpoints } from "../../Lib/Endpoints";

const HomePage: React.FC = () => {
  //CHECK FOR SEARCH PARAM "ORIGIN"
  const origin = new URLSearchParams(window.location.search).get("origin");
  if (origin) {
    const isOriginAlreadyRecorded = localStorage.getItem("origin");
    if (!isOriginAlreadyRecorded) {
      localStorage.setItem("origin", origin);
      const recordUserVisit = async () => {
        await PerformRequest({
          method: "GET",
          route: Endpoints.GetRecordUserVisit(origin),
          callback: () => {
            window.history.replaceState({}, "", window.location.pathname);
          },
        });
        window.history.replaceState({}, "", window.location.pathname);
      };
      recordUserVisit();
    }
  }
  document.title = `Home | ${AppName}`;
  return (
    <>
      <div className="homepage-container">
        <HomeNav />
        <HomeHeroSection />
        <HomeBanners />
        <HomeHowItWorks />
        <HomeGetInTouch />
        <HomeFAQs />
        <HomeFooter />
      </div>
    </>
  );
};

export default HomePage;
